(() => {
  // Deterrent only: photographs must remain public for browsing and image search.
  // Delegation also covers images hydrated later by search, galleries and quick add.
  const imageSurfaceSelector = 'img, .product__modal-opener--image, .product-media-modal__content';

  function preventImageDownload(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const surface = target.closest(imageSurfaceSelector);
    const image = surface && (surface.matches('img') ? surface : surface.querySelector('img'));
    // Dragging a linked photograph can start on its enclosing, image-only link.
    const linkedImage = event.type === 'dragstart' && target.matches('a') &&
      !target.textContent.trim() && target.querySelector('img');

    if (image || linkedImage) event.preventDefault();
  }

  document.addEventListener('contextmenu', preventImageDownload, { capture: true });
  document.addEventListener('dragstart', preventImageDownload, { capture: true });
})();
